import { defineStore } from "pinia";
import { getSpotOptions } from "@/common/api.service";

export const useOptionsStore = defineStore("spotOptions", {
  state: () => ({
    options: {
      incidents: []
    },
  }),
  getters: {
    incidentLegend() {
      return this.options.incidents.reduce((acc, incident) => {
        // Key is used to group, label used to display the group
        let key = incident.category === 'Fire' ? incident.description : incident.category;

        const existingIncident = acc.find(accCurr => accCurr.key === key)
        if (existingIncident) {
          existingIncident.ids.push(incident.id)
        } else {
          let label = incident.description;
          if (incident.category === 'Fire' || incident.category === 'Other') {
            label = key;
          } else {
            label = label.replace(/ .*/, "").replace(/,.*/, "")
          }

          acc.push({
            ids: [incident.id],
            key: key,
            label: label,
            mark: label.charAt(0)
          });
        }
        return acc;
      }, []);
    },
    incidentLegendMap() {
      const map = new Map();
      this.incidentLegend.forEach(incident => {
        incident.ids.forEach(incidentId => {
          map.set(incidentId, incident)
        })
      })
      return map;
    }
  },
  actions: {
    async fillSpotOptions() {
      this.options = await getSpotOptions();
    },
  },
});
